import { Open } from '@velocity-exchange/icons';

import { UiVaultConfig } from 'src/@types/vaults';
import { cm } from 'src/utils/classNames';
import { PageRoute, VAULT_VIEW_TAB_OPTIONS } from '../../constants/constants';
import Button from '../primitives/Button/Button';
import { useWindowSizeIsLessThan } from 'src/hooks/useWindowSize';
import usePostHogCapture from 'src/hooks/posthog/usePostHogCapture';

export default function VaultViewActions({
	type = 'view',
	...props
}: {
	uiVaultConfig: UiVaultConfig;
	condensed?: boolean;
	classes?: {
		buttons?: string;
		wrapper?: string;
	};
	type?: 'view' | 'manage';
	isClosedPosition?: boolean;
}) {
	const { captureEvent } = usePostHogCapture();
	const lessThanTabletSize = useWindowSizeIsLessThan('md');
	const vaultText = lessThanTabletSize ? 'View' : 'View Vault';

	const isDeprecating = props.uiVaultConfig.isDeprecating;

	return (
		<div
			className={cm(
				'flex w-full items-center justify-end',
				props.condensed ? 'gap-1' : 'gap-2',
				props.classes?.wrapper
			)}
		>
			{isDeprecating && !props.isClosedPosition && (
				<Button
					size="sm"
					variant="primary"
					className="max-w-25 flex-1"
					as="a"
					href={
						props.uiVaultConfig.externalUiLink
							? props.uiVaultConfig.externalUiLink
							: `/${PageRoute.vaults}/strategy-vaults/${
									props.uiVaultConfig.vaultPubkeyString
								}${
									type === 'manage'
										? `?tab=${VAULT_VIEW_TAB_OPTIONS.UserPerformance}`
										: ''
								}`
					}
					openInNewTab={!!props.uiVaultConfig.externalUiLink}
					onClick={(e) => e.stopPropagation()}
				>
					Withdraw
				</Button>
			)}

			{!(isDeprecating && type === 'manage' && !props.isClosedPosition) && (
				<Button
					size="sm"
					variant="secondary"
					className="max-w-25 flex-1"
					as="a"
					href={
						props.uiVaultConfig.externalUiLink
							? props.uiVaultConfig.externalUiLink
							: `/${PageRoute.vaults}/strategy-vaults/${
									props.uiVaultConfig.vaultPubkeyString
								}${
									type === 'manage'
										? `?tab=${VAULT_VIEW_TAB_OPTIONS.UserPerformance}`
										: ''
								}`
					}
					openInNewTab={!!props.uiVaultConfig.externalUiLink}
					rightIcon={props.uiVaultConfig.externalUiLink ? Open : undefined}
					onClick={(e) => {
						e.stopPropagation();

						if (type === 'view') {
							captureEvent('vault_viewed');
						}
					}}
				>
					{type === 'view' ? vaultText : 'Manage'}
				</Button>
			)}
		</div>
	);
}
